<template>
  <ut-form :label-width="200">
    <ut-input placeholder="应用ID" v-model="appId" :style="{width:'500px'}" v-show="false"></ut-input>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 名称
      </template>
      <ut-input placeholder="应用名称" v-model="appName" :style="{width:'500px'}"></ut-input>
    </ut-form-item>

    <ut-form-item label="系统级别">
      <ut-select v-model="selected1" :style="{width:'500px'}">
        <ut-option
          v-for="item in levelOptions"
          :value="item.value"
          :key="item.value"
          :label="item.label"
          :selected="selected1"
        ></ut-option>
      </ut-select>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 负责人
      </template>
      <ut-select v-model="selected2" multiple filterable :style="{width:'500px'}" :filter-method='filter'>
        <ut-option v-for="item in selectedSearchUsers||selectedUser" :value="item.id" :key="item.id" :label="item.name"></ut-option>
      </ut-select>
    </ut-form-item>
    <ut-form-item label="描述">
      <ut-input
        type="textarea"
        placeholder="描述"
        v-model="description"
        autosize
        style="margin-bottom:10px"
        :style="{width:'500px'}"
      ></ut-input>
    </ut-form-item>
    <ut-form-item>
      <ut-button type="primary" @click="submit">立即更新</ut-button>
      <ut-button @click="goBack">取消</ut-button>
    </ut-form-item>
  </ut-form>
</template>

<script lang="babel">
export default {
  data () {
    return {
      appId: '',
      appName: '',
      selected1: '',
      selected2: '',
      description: '',
      levelOptions: [
        // {
        //   value: '0',
        //   label: '0级别系统'
        // },
        {
          value: '1',
          label: '1级别系统'
        },
        {
          value: '2',
          label: '2级别系统'
        },
        {
          value: '3',
          label: '3级别系统'
        }
      ],
      selectedSearchUsers: null,
      selectedUser: []
    }
  },
  methods: {
    submit () {
      var appId = this.appId
      var appName = this.appName
      if (appId == '') {
        this.$message.error('应用Id不能为空！')
        return false
      }
      if (appName == '') {
        this.$message.error('应用名称不能为空！')
        return false
      }
      if (this.description == '') {
        this.$message.error('描述不能为空！')
        return false
      }
      if (this.selected1 == '') {
        this.$message.error('系统级别不能为空！')
        return false
      }
      if (this.selected2 == '') {
        this.$message.error('负责人不能为空！')
        return false
      }
      var sendData = {}
      sendData.appId = this.appId
      sendData.appName = this.appName
      sendData.description = this.description
      sendData.level = this.selected1
      sendData.userIds = this.selected2
      console.log(JSON.stringify(sendData))
      this.$http({
        method: 'post',
        url: 'apps/update.htm',
        data: JSON.stringify(sendData)
      })
        .then(response => {
          // 这里使用了ES6的语法
          console.log(response) // 请求成功返回的数据
          if (response.data.code == 0) {
            this.$message.success('更新成功')
            var callbackUrl = this.$route.query.callbackUrl
            if (callbackUrl) {
              this.$router.push({ path: callbackUrl })
            } else {
              this.$router.push({ path: '/apps' })
            }
          } else {
            this.$message.error(response.data.message)
            return false
          }
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    goBack () {
      var callbackUrl = this.$route.query.callbackUrl
      if (callbackUrl) {
        this.$router.push({ path: callbackUrl })
      } else {
        this.$router.push({ path: '/apps' })
      }
    },
    filter (val) {
      const data = []
      const inp = val && val.toLowerCase()
      this.selectedUser.map(item => {
        if (item.name.includes(inp) || item.id.toLowerCase().includes(inp)) {
          data.push(item)
        }
      })
      if (data.length) {
        this.selectedSearchUsers = data
      } else {
        this.selectedSearchUsers = null
      }
    }
  },
  async created () {
    await this.$http({
      method: 'post',
      url: 'users/list.htm',
      data: '{}'
    })
      .then(response => {
        // 这里使用了ES6的语法
        console.log(response) // 请求成功返回的数据
        this.selectedUser = response.data
      })
      .catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    console.log('开始请求')
    this.$http({
      method: 'post',
      url: 'apps/' + this.$route.query.id + '/get.htm',
      data: '{}'
    })
      .then(response => {
        // 这里使用了ES6的语法
        console.log(response) // 请求成功返回的数据
        this.appId = response.data.appId
        this.appName = response.data.appName
        this.description = response.data.description
        this.selected1 = response.data.level
        this.selected2 = response.data.owners
        var users = ''
        for (var r = 0; r < response.data.owners.length; r++) {
          users += response.data.owners[r].id + ','
        }
        var temp = []
        var value = []
        for (var l of this.levelOptions) {
          if (l.value == response.data.level) {
            this.selected1 = l.value
          }
        }

        var index = 0
        var userStr = users.split(',')
        console.log('users : ' + users)
        console.log(userStr)
        for (var n = 0; n < this.selectedUser.length; n++) {
          for (var a = 0; a < userStr.length; a++) {
            if ((userStr[a]) === this.selectedUser[n].id) {
              console.log(this.selectedUser[n])
              temp[index] = this.selectedUser[n].name
              value[index] = this.selectedUser[n].id
              index++
            }
          }
        }
        this.selected2 = value
      })
      .catch(error => {
        console.log(error) // 请求失败返回的数据
      })
  }
}
</script>
